"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = require("react");
var _isSyntheticEvent = _interopRequireDefault(require("../isSyntheticEvent"));
var _sanitize = _interopRequireDefault(require("../sanitize"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function useStepByStepFormUnlocker(_ref) {
  var mapping = _ref.mapping,
    submitUrlStructure = _ref.submitUrlStructure,
    onSubmitCallback = _ref.onSubmitCallback,
    history = _ref.history;
  var getNextFieldKey = function getNextFieldKey(_ref2) {
    var currentFieldIndex = _ref2.currentFieldIndex,
      state = _ref2.state;
    return Object.keys(state).filter(function (key) {
      return state[key].index === currentFieldIndex + 1;
    })[0];
  };
  var getNextField = function getNextField(_ref3) {
    var currentFieldIndex = _ref3.currentFieldIndex,
      state = _ref3.state;
    var nextFieldKey = getNextFieldKey({
      currentFieldIndex: currentFieldIndex,
      state: state
    });
    return Object.assign({}, state[nextFieldKey]);
  };
  var getCurrentFieldKey = function getCurrentFieldKey(_ref4) {
    var _ref4$currentFieldInd = _ref4.currentFieldIndex,
      currentFieldIndex = _ref4$currentFieldInd === void 0 ? -1 : _ref4$currentFieldInd,
      state = _ref4.state;
    var nextFieldKey = getNextFieldKey({
      currentFieldIndex: currentFieldIndex,
      state: state
    });
    if (nextFieldKey) {
      var nextField = state[nextFieldKey];
      if (nextField.data) {
        return getCurrentFieldKey({
          currentFieldIndex: nextField.index,
          state: state
        });
      }
    }
    return nextFieldKey;
  };
  var setDefaultValues = function setDefaultValues(passedState) {
    var defaultKeys = Object.keys(passedState).sort(function (a, b) {
      return passedState[a].index - passedState[b].index;
    }).filter(function (key) {
      return typeof passedState[key].defaultValue !== 'undefined';
    });
    var newState = Object.assign({}, passedState);
    defaultKeys.forEach(function (key, i) {
      var field = newState[key];
      var defaultValue = field.defaultValue,
        index = field.index;
      field.passedValidation = true;
      field.disabled = false;
      field.value = defaultValue;
      var nextField = getNextField({
        currentFieldIndex: index,
        state: newState
      });
      if (typeof nextField !== 'undefined' && nextField.originalKey) {
        nextField.disabled = false;
        newState[nextField.originalKey] = nextField;
      }
    });
    return newState;
  };
  var getInitialFormState = function getInitialFormState(mapping) {
    var initialFormState = {};
    var nonIndexedKeys = Object.keys(mapping).filter(function (key) {
      return typeof mapping[key].index === 'undefined';
    });
    var initialFormStateKeys = Object.keys(mapping).filter(function (key) {
      return typeof mapping[key].index !== 'undefined';
    }).sort(function (a, b) {
      return mapping[a].index - mapping[b].index;
    });
    [].concat((0, _toConsumableArray2["default"])(initialFormStateKeys), (0, _toConsumableArray2["default"])(nonIndexedKeys)).forEach(function (key, i) {
      initialFormState[key] = Object.assign({}, mapping[key]);
      var field = initialFormState[key];
      var _initialFormState$key = initialFormState[key],
        nonSequential = _initialFormState$key.nonSequential,
        index = _initialFormState$key.index;
      field.disabled = nonSequential ? false : index !== 0;
      field.index = index ? index : i;
      field.passedValidation = field.defaultToValid || false;
    });
    return setDefaultValues(initialFormState);
  };
  var _useState = (0, _react.useState)(getInitialFormState(mapping)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    formState = _useState2[0],
    updateFormState = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    submitUrl = _useState4[0],
    updateSubmitUrl = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    submitIsDisabled = _useState6[0],
    disableSubmit = _useState6[1];
  var getFieldState = function getFieldState(e, passedState) {
    var el = e.currentTarget || e.target || e;
    var isSynthetic = (0, _isSyntheticEvent["default"])(e);
    var fieldIndex = isSynthetic ? el && parseInt(el.getAttribute('data-field-index')) : e && e.index;
    var currentState = Object.assign({}, passedState || formState);
    var currentFieldKey = Object.keys(currentState).filter(function (key) {
      return currentState[key].index === fieldIndex;
    })[0];
    return {
      fieldState: currentState[currentFieldKey],
      isSynthetic: isSynthetic,
      el: el,
      fieldIndex: fieldIndex,
      currentFieldKey: currentFieldKey,
      currentState: currentState,
      elValue: el && el.value
    };
  };
  var updateWithValidators = function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(validator, nonSequential, fieldIndex, elValue, el, passedState) {
      var newFormState, disabled, isValid, validatedFormState;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newFormState = Object.assign({}, passedState || formState);
              disabled = false;
              updateFormState(newFormState);
              if (!(typeof validator === 'function')) {
                _context.next = 9;
                break;
              }
              _context.next = 6;
              return validator(el);
            case 6:
              _context.t0 = _context.sent;
              _context.next = 10;
              break;
            case 9:
              _context.t0 = true;
            case 10:
              isValid = _context.t0;
              validatedFormState = Object.keys(newFormState).reduce(function (acc, key) {
                var field = newFormState[key];
                var index = field.index;
                if (index === fieldIndex + 1) {
                  disabled = !isValid;
                } else if (index > fieldIndex + 1) {
                  disabled = true;
                }
                field.disabled = nonSequential ? field.disabled : field.nonSequential ? false : disabled;
                field.passedValidation = index === fieldIndex ? isValid : !field.nonSequential && index > fieldIndex ? false : field.passedValidation;
                field.pendingValidation = index === fieldIndex ? false : field.pendingValidation;
                return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, key, field));
              }, {});
              updateFormState(validatedFormState);
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function updateWithValidators(_x, _x2, _x3, _x4, _x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();
  var fieldOnChange = function fieldOnChange(e, passedState) {
    var currentState = passedState || formState;
    var _getFieldState = getFieldState(e, currentState),
      fieldState = _getFieldState.fieldState,
      el = _getFieldState.el,
      fieldIndex = _getFieldState.fieldIndex,
      elValue = _getFieldState.elValue;
    var validator = fieldState.validator,
      nonSequential = fieldState.nonSequential;
    var newFormState = Object.assign({}, currentState);
    Object.keys(newFormState).forEach(function (key) {
      var field = newFormState[key];
      var index = field.index;
      field.value = index === fieldIndex ? elValue : index < fieldIndex || field.nonSequential ? field.value : '';
      field.pendingValidation = index === fieldIndex;
    });
    updateWithValidators(validator, nonSequential, fieldIndex, elValue, el, newFormState);
  };
  var onSubmit = function onSubmit(e) {
    if (typeof history !== 'undefined') {
      e.preventDefault();
      history.push(submitUrl, {
        fromStepFormSubmit: true
      });
    }
    if (typeof onSubmitCallback !== 'undefined') {
      onSubmitCallback(e, formState);
    }
  };
  var checkAndEnableFormSubmit = function checkAndEnableFormSubmit() {
    var fieldKeys = Object.keys(formState);
    var fieldsValidated = fieldKeys.filter(function (key) {
      var _formState$key = formState[key],
        passedValidation = _formState$key.passedValidation,
        nonRequired = _formState$key.nonRequired;
      return passedValidation || nonRequired;
    }).length;
    var allFieldsValidated = fieldKeys.length === fieldsValidated;
    var url = submitUrlStructure;
    disableSubmit(!allFieldsValidated);
    if (url && allFieldsValidated) {
      fieldKeys.forEach(function (key) {
        var value = formState[key].value;
        url = url.replace("{".concat(key, "}"), (0, _sanitize["default"])(value));
      });
      updateSubmitUrl(url);
    }
  };
  (0, _react.useEffect)(checkAndEnableFormSubmit, [formState]);
  (0, _react.useEffect)(function () {
    var newFormState = Object.assign({}, formState);
    var updated = false;
    Object.keys(newFormState).forEach(function (fieldName) {
      var field = newFormState[fieldName];
      var mappedFieldName = mapping[fieldName];
      if (typeof mappedFieldName !== 'undefined' && mappedFieldName.defaultValue !== field.defaultValue) {
        field.value = mappedFieldName.defaultValue;
        updated = true;
      }
    });
    if (updated) {
      updateFormState(newFormState);
    }
  }, [Object.keys(mapping).map(function (field) {
    return mapping[field].defaultValue;
  })]);
  return {
    formState: formState,
    fieldOnChange: fieldOnChange,
    getNextFieldKey: getNextFieldKey,
    getNextField: getNextField,
    getCurrentFieldKey: getCurrentFieldKey,
    getFieldState: getFieldState,
    submitIsDisabled: submitIsDisabled,
    updateFormState: updateFormState,
    getInitialFormState: getInitialFormState,
    onSubmit: onSubmit,
    submitUrl: submitUrl,
    setDefaultValues: setDefaultValues
  };
}
var _default = useStepByStepFormUnlocker;
exports["default"] = _default;